/* tslint:disable */

/**
 */
export class ModelChaining {
    studyName?: string;
    ID_STUDY?: number;
    active?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/model-chaining.ts